import GridColumnInputWrapper from '@components/common/GridColumnInputWrapper';
import { Card } from 'semantic-ui-react';
import { useTranslation } from 'react-i18next';
import styles from '../styles/Activity.module.scss';
import ExternalDocumentTagsUrlInputWrapper from '@components/common/ExternalDocumentTagsUrlInputWrapper';
import { useFormContext } from 'react-hook-form';
import { useEffect } from 'react';
import { edmsReferenceValidation } from '@components/Activity/types/Validations';

type Props = {
  atexZone: string;
  setAtexZone?: (atexZone: string) => void;
  disabled?: boolean;
};

const RiskAtexZone = ({ atexZone, setAtexZone, disabled }: Props) => {
  const { t } = useTranslation();
  const {
    register,
    formState: { errors },
    setValue,
    trigger,
  } = useFormContext();

  useEffect(() => {
    setValue('atexZone', atexZone);
    trigger(['atexZone']);
  }, [atexZone]);

  const registerZone = register('atexZone', edmsReferenceValidation(t));

  return (
    <div className={`${styles.basicDiv}${styles.activityTextContainer}`}>
      <Card className={styles.cardText}>
        <div className={styles.atexContainer}>
          <div className={styles.activityTextHeader}>
            {t('risk.assessment.details.page.risk.details.container.atexZone.title')}
          </div>
          <div className={styles.inputWrapper}>
            <label>{t('risk.assessment.details.page.risk.details.container.atexZone.label')}</label>
            <div className={styles.errorMessage}>{errors?.atexZone?.message?.toString()}</div>
            <GridColumnInputWrapper
              value={atexZone}
              rows={1}
              disabled={disabled}
              render={(props: Record<string, unknown>) => (
                <ExternalDocumentTagsUrlInputWrapper
                  {...registerZone}
                  {...props}
                  onlyUnique={true}
                  onlyAutocomplete={false}
                  value={atexZone}
                  setFieldValue={(field: string, value: string) => {
                    setAtexZone?.(value);
                  }}
                  placeholder={t(
                    'risk.assessment.details.page.risk.details.container.atexZone.placeholder'
                  )}
                  maxTags={1}
                />
              )}
            />
          </div>
        </div>
      </Card>
    </div>
  );
};

export default RiskAtexZone;
